import React, { useState, useContext, useEffect } from 'react'
import { motion } from 'framer-motion'
/*COMPONENTS */
import Header from '../../components/Header'
import DashboardGrafical from '../../components/DashboardGrafical'
import SidebarEl from '../../components/SidebarEl'
import styled from 'styled-components'
import MobileMenu from '../../components/MobileMenu'
import { DashboardContext } from '../../context/dashboard'
import TableListCarts from '../../components/TableListCarts/'
import ModalRequestCart from '../../components/ModalRequestCart'
import { ToastContainer, toast } from 'react-toastify';
import { CartsContext } from '../../context/cart'

const CardWrapper = styled.section`
    background-color: #fafafa;
    height: 100vh;
    display: flex;

   
  
    .colum_primary{ 
        flex:0.1;
    }


    .colum_secondary{
        display: flex;
        flex:1;
        padding: 1.7rem;
        flex-direction: column;
        width: 100%;
    }

    @media screen and (max-width:720px){
    .colum_primary{ 
        flex:0;

    }

        .colum_secondary{
        display: flex;
        flex:1;
        flex-direction: column;
        width: 100%;
    }
    }

`
const CleanMobile = styled.div`

@media screen and (max-width:720px){
        height:120px
    }

`
const RowDashboard = styled.div`

    display: flex;
    justify-content:space-between; 
    align-items: center;

    @media screen and (max-width:720px){
        width: 100%;
        flex-direction: column;
    }

`
const FixWidthSidebar = styled.div`
    display: block;
    width: 130px;
    @media screen and (min-width:1800px){
        display: block;
        width: 90px;
    }

    @media screen and (max-width:820px){
        display: none;
    }


`
const Carts = () => {
    const {getAll,totalCartsLoss} = useContext(DashboardContext)
    const {showModalRequest,setShowModalRequest} = useContext(CartsContext)

    const [data,setData] = useState([])
    const [structure] = useState([
        {
            name: "Id",
        },
        {
            name: "Cliente",
        },
        {
            name: "Status"
        },


    ])


    useEffect(() => {
        getAll()
    },[])

    function ModalClientCart(props) {
        return (
            <ModalRequestCart props={props} />
        );
    }


    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            <ToastContainer />
            <CardWrapper>
                <div className='colum_primary'>
                    <SidebarEl />
                </div>

                <FixWidthSidebar/>

                <div className='colum_secondary'>
                    <Header name="Carrinhos Perdidos"  />
                    <RowDashboard>
                        <DashboardGrafical name={"N Carrinhos"} value={totalCartsLoss} width={"27%"} marginTop={"0px"}/>
                    </RowDashboard>
                    <TableListCarts structure={structure} />
                </div>

                
                <ModalClientCart
                show={showModalRequest}
                onHide={() => setShowModalRequest(false)}

                />
                <MobileMenu />

            </CardWrapper>
        </motion.div>

    )
}

export default Carts